import React from 'react';
import { Link } from 'react-router-dom';
import './Navigation.css';

const Navigation: React.FC = () => {
  return (
    <nav className="navigation">
      <div className="nav-content">
        <Link to="/" className="nav-title">
          <img src="/logo_transparent.png" alt="MyWordBuddy Logo" />
          MyWordBuddy
        </Link>
        <div className="nav-links">
          <Link to="/about" className="nav-link">About</Link>
        </div>
      </div>
    </nav>
  );
};

export default Navigation;